<div [hidden]="showRequest">
    <h2 *ngIf="!IsAdminMode" class="sectionTitle">{{'FRONT_USER.small_units.Form' | translate }}
    </h2>

    <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>

    <div *ngIf="showMoreInfo">
        <div class="form-container">
            <h4 class="section-title">{{'FRONT_USER.small_units.REQUIRED_INFORMATION'| translate}}</h4>
            <div class="form-group">
                <label for="SmallUnitMoreInformation">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
                    translate}}</label>
                <textarea [(ngModel)]="moreInfomation" id="SmallUnitMoreInformation" name="SmallUnitMoreInformation"
                    disabled class="form-control"></textarea>
            </div>
        </div>
    </div>
   <div *ngIf="showPrintPdf">
        <div class="form-container">
            <div class="form-group">
                <h4 class="section-title">{{'FRONT_USER.small_units.PRINTINVOICE' | translate }}</h4>
                <div class="form-group">
                    <a class="export-link" href="#" (click)="exportapdf($event)">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            aria-hidden="true" role="img" width="1.25em" height="1.25em"
                            preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
                            <path
                                d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z"
                                fill="currentColor" />
                            <path
                                d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z"
                                fill="currentColor" />
                        </svg>
                        <span>{{'FRONT_USER.small_units.PRINT' | translate }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showMoreInfo2">
        <div class="form-container">
            <h4 class="section-title">{{'FRONT_USER.small_units.REQUIRED_INFORMATION_FEES_ESTIMATE'| translate}}</h4>
            <div class="form-group">
                <label for="SmallUnitMoreInformation2">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' |
                    translate}}</label>
                <textarea [(ngModel)]="moreInfomation2" id="SmallUnitMoreInformation2" name="SmallUnitMoreInformation2"
                    disabled class="form-control"></textarea>
            </div>
        </div>
    </div>

    <!-- Request-->
    <form [formGroup]="entranceRequestForm" #EntranceRequest>
        <div>
            <div class="form-container">
                <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>
            </div>
            <tabset #entranceRequestTabs>
                <tab #tabOneControls heading="{{ 'FRONT_USER.small_units.Unit_info_header' | translate}}">
                    <div class="form-container">
                        <div class="form-group">
                            <label for="UnitName">{{ 'FRONT_USER.small_units.UnitName' | translate}}</label>
                            <span class="red"> *</span>
                            <input type="text" name="UnitName" id="UnitName" class="form-control text-uppercase"
                                formControlName="UnitName" />
                            <div *ngIf="isTabOneSubmitted || (f.UnitName?.dirty && f.UnitName?.errors)" class="red ">
                                <div *ngIf="f.UnitName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="RegisterNo">{{ 'FRONT_USER.small_units.RegisteragionNo' | translate}}</label>
                            <span class="red"> *</span>
                            <input type="text" name="RegisterNo" id="RegisterNo" class="form-control"
                                formControlName="RegisterNo" />
                            <div *ngIf="isTabOneSubmitted || (f.RegisterNo?.dirty && f.RegisterNo?.errors)"
                                class="red ">
                                <div *ngIf="f.RegisterNo?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.RegisterNo?.errors?.pattern">

                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="CrewNo">{{ 'FRONT_USER.small_units.CrewNo' | translate}}</label>
                            <span class="red"> *</span>
                            <input type="text" name="CrewNo" id="CrewNo" class="form-control"
                                formControlName="CrewNo" />
                            <div *ngIf="isTabOneSubmitted || (f.CrewNo?.dirty && f.CrewNo?.errors)" class="red ">
                                <div *ngIf="f.CrewNo?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.CrewNo?.errors?.pattern">
                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                            <!--<div *ngIf="f.CrewNo?.errors?.max" class="red" >
                                {{'ADMIN_USER.SmallUnits.Crew_no' | translate}}
                            </div>-->
                        </div>
                        <div class="form-group">
                            <label for="NationalityId">{{ 'FRONT_USER.small_units.SHIP_NATIONALITY' |
                                translate}}</label>
                            <span class="red">*</span>
                            <select formControlName="NationalityId" class="form-control" id="NationalityId"
                                name="NationalityId">
                                <option [value]="''" selected>
                                    {{'FRONT_USER.small_units.CHOOSE_NATIONALITY' | translate}}
                                </option>
                                <ng-container *ngFor="let nationality of nationalities">
                                    <option *ngIf="displayedLang==Languages.English" [value]="nationality.Id">
                                        {{nationality.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="nationality.Id">
                                        {{nationality.NameAR}}
                                    </option>
                                </ng-container>
                            </select>

                            <div *ngIf="isTabOneSubmitted || (f.NationalityId?.dirty && f.NationalityId?.errors)"
                                class="red ">
                                <div *ngIf="f.NationalityId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="DirectionId">{{ 'FRONT_USER.small_units.Direction' | translate}}</label>
                            <span class="red">*</span>

                            <select formControlName="DirectionId" class="form-control" id="DirectionId"
                                name="DirectionId">
                                <option [value]="''" selected>
                                    {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_DIRECTION' | translate}}</option>


                                <ng-container *ngFor="let sailDirection of directions">
                                    <option *ngIf="displayedLang==Languages.English" [value]="sailDirection?.Id">
                                        {{sailDirection?.Direction}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="sailDirection?.Id">
                                        {{sailDirection?.DirectionAR}}
                                    </option>
                                </ng-container>

                            </select>
                            <div *ngIf="isTabOneSubmitted || (f.DirectionId?.dirty && f.DirectionId?.errors)"
                                class="red ">
                                <div *ngIf="f.DirectionId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="SelectedCurrencyId">{{'FRONT_USER.FEES_ESTIMATION_FORM.PAYMENT_CURRENCY'|
                                translate}}</label>
                            <span class="red">*</span>
                            <select formControlName="SelectedCurrencyId" class="form-control" id="SelectedCurrencyId"
                                name="SelectedCurrencyId">

                                <option [value]="''" selected>
                                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.CURRENCY_CHOOSE' | translate}}
                                </option>
                                <ng-container *ngFor="let currency of AgentCurrencies">
                                    <option *ngIf="displayedLang==Languages.English" [value]="currency.Id">
                                        {{currency.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="currency.Id">
                                        {{currency.NameAR}}
                                    </option>
                                </ng-container>

                            </select>
                            <div *ngIf="isTabOneSubmitted ||(f.SelectedCurrencyId?.dirty && f.SelectedCurrencyId?.errors)"
                                class="red ">
                                <div *ngIf="f.SelectedCurrencyId?.errors?.required ">
                                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="Length">{{ 'FRONT_USER.small_units.Length' | translate}}</label>
                            <span class="red">*</span>
                            <input type="text" name="Length" id="Length" class="form-control"
                                formControlName="Length" />
                            <div *ngIf="isTabOneSubmitted || (f.Length?.dirty && f.Length?.errors)" class="red ">
                                <div *ngIf="f.Length?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.Length?.errors?.pattern">

                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="Width">{{ 'FRONT_USER.small_units.Width' | translate}}</label>
                            <span class="red">*</span>
                            <input type="text" name="Width" id="Width" class="form-control" formControlName="Width" />
                            <div *ngIf="isTabOneSubmitted || (f.Width?.dirty && f.Width?.errors)" class="red ">
                                <div *ngIf="f.Width?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.Width?.errors?.pattern">

                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="Depth">{{ 'FRONT_USER.small_units.Depth' | translate}}</label>
                            <span class="red">*</span>
                            <input type="text" name="Depth" id="Depth" class="form-control" formControlName="Depth" />
                            <div *ngIf="isTabOneSubmitted || (f.Depth?.dirty && f.Depth?.errors)" class="red ">
                                <div *ngIf="f.Depth?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.Depth?.errors?.pattern">

                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="FromCountryId">{{ 'FRONT_USER.small_units.LastCountryofOrigin' | translate
                                }}</label>
                            <span class="red"> *</span>
                            <select formControlName="FromCountryId" class="form-control" id="FromCountryId"
                                name="FromCountryId">
                                <option value="" selected>{{ 'FRONT_USER.small_units.CHOOSE' | translate }}</option>
                                <ng-container *ngFor="let country of countries">
                                    <option *ngIf="displayedLang==Languages.English" [value]="country?.Id">
                                        {{country?.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="country?.Id">
                                        {{country?.NameAR}}
                                    </option>
                                </ng-container>
                            </select>
                            <div *ngIf="isTabOneSubmitted || (f.FromCountryId?.dirty && f.FromCountryId?.errors)"
                                class="red ">
                                <div *ngIf="f.FromCountryId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="ToCountryId">{{ 'FRONT_USER.small_units.FirstCountryofDestination' | translate
                                }}</label>
                            <span class="red"> *</span>
                            <select formControlName="ToCountryId" class="form-control" id="ToCountryId"
                                name="ToCountryId">
                                <option value="" selected>{{ 'FRONT_USER.small_units.CHOOSE' | translate }}</option>
                                <ng-container *ngFor="let country of countries">
                                    <option *ngIf="displayedLang==Languages.English" [value]="country?.Id">
                                        {{country?.NameEN}}
                                    </option>
                                    <option *ngIf="displayedLang==Languages.Arabic" [value]="country?.Id">
                                        {{country?.NameAR}}
                                    </option>
                                </ng-container>
                            </select>
                            <div *ngIf="isTabOneSubmitted || (f.ToCountryId?.dirty && f.ToCountryId?.errors)"
                                class="red ">
                                <div *ngIf="f.ToCountryId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="ArrivalDate">{{ 'FRONT_USER.small_units.ArrivalDate' | translate }}</label>
                            <span class="red">*</span>
                            <div class="split-form-group ">
                                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
                                    formControlName="ArrivalDate" (ngModelChange)="compareLastTransit()">
                                <div *ngIf="isTabOneSubmitted ||(f.ArrivalDate?.dirty && f.ArrivalDate?.errors)"
                                    class="red ">
                                    <div *ngIf="f.ArrivalDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                        translate}}
                                    </div>
                                    <div *ngIf="f.ArrivalDate?.errors?.inValidDateError">
                                        {{'FRONT_USER.DATE_ERROR' | translate}}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="form-group">
                            <label for="UnitTypeId">{{ 'FRONT_USER.small_units.unitType' | translate }}</label>
                            <span class="red"> *</span>
                            <select formControlName="UnitTypeId" class="form-control" id="UnitTypeId" name="UnitTypeId">
                                <option value="" selected>{{ 'FRONT_USER.small_units.CHOOSE' | translate }}</option>

                                <option [value]="1">
                                    {{ 'FRONT_USER.small_units.Catamaran' | translate }}
                                </option>
                                <option [value]="2">
                                    {{ 'FRONT_USER.small_units.Yacht' | translate }}
                                </option>
                            </select>
                            <div *ngIf="isTabOneSubmitted || (f.UnitTypeId?.dirty && f.UnitTypeId?.errors)"
                                class="red ">
                                <div *ngIf="f.UnitTypeId?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="LastTransitDate">{{ 'FRONT_USER.small_units.LastTransitDate' | translate
                                }}</label>
                            <div class="split-form-group ">
                                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
                                    formControlName="LastTransitDate" [minDate]="null" [maxDate]="todayDate"
                                    (ngModelChange)="compareLastTransit()">
                            </div>
                            <div *ngIf="isTabOneSubmitted ||(f.LastTransitDate?.dirty && f.LastTransitDate?.errors)"
                                class="red ">
                                <div *ngIf="f.LastTransitDate?.errors?.invalid">
                                    {{'FRONT_USER.DATE_ERROR' | translate}}
                                </div>
                            </div>
                            <div *ngIf="errorLastTransit.isError" class="red">
                                {{ errorLastTransit.errorMessage }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="NetTonnage">{{ 'FRONT_USER.small_units.NetTonnage' | translate}}</label>
                            <span class="red">*</span>
                            <input type="text" name="NetTonnage" id="NetTonnage" class="form-control"
                                formControlName="NetTonnage" />
                            <div *ngIf="isTabOneSubmitted || (f.NetTonnage?.dirty && f.NetTonnage?.errors)"
                                class="red ">
                                <div *ngIf="f.NetTonnage?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.NetTonnage?.errors?.pattern">

                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>

                            </div>
                            <div *ngIf="f.NetTonnage?.errors?.max" class="red">

                                {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_NET_TONNAGE' | translate}}
                            </div>

                        </div>
                        <div class="form-group">
                            <label for="GrossTonnage">{{ 'FRONT_USER.small_units.GrossTonage' | translate}}</label>
                            <span class="red">*</span>
                            <input type="text" name="GrossTonnage" id="GrossTonnage" class="form-control"
                                formControlName="GrossTonnage" />
                            <div *ngIf="isTabOneSubmitted || (f.GrossTonnage?.dirty && f.GrossTonnage?.errors)"
                                class="red ">
                                <div *ngIf="f.GrossTonnage?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |
                                    translate}}</div>
                                <div *ngIf="f.GrossTonnage?.errors?.pattern">

                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                            <div *ngIf="f.GrossTonnage?.errors?.max" class="red">
                                {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_Gross_TONNAGE' | translate}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="SCNetTonnage">{{ 'FRONT_USER.small_units.SCNT' | translate}}</label>

                            <input type="text" name="SCNetTonnage" id="SCNetTonnage" class="form-control"
                                formControlName="SCNetTonnage" />
                            <div *ngIf="isTabOneSubmitted || (f.SCGrossTonnage?.dirty && f.SCGrossTonnage?.errors)"
                                class="red ">
                                <div *ngIf="f.SCNetTonnage?.errors?.pattern">
                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                            <div *ngIf="f.SCNetTonnage?.errors?.max" class="red">

                                {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_NET_TONNAGE' | translate}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="SCGrossTonnage">{{ 'FRONT_USER.small_units.SCGT' | translate}}</label>

                            <input type="text" name="SCGrossTonnage" id="SCGrossTonnage" class="form-control"
                                formControlName="SCGrossTonnage" />
                            <div *ngIf="isTabOneSubmitted || (f.SCGrossTonnage?.dirty && f.SCGrossTonnage?.errors)"
                                class="red ">
                                <div *ngIf="f.SCGrossTonnage?.errors?.pattern">
                                    {{'FRONT_USER.NUMBER_ERROR' | translate}}
                                </div>
                            </div>
                            <div *ngIf="f.SCGrossTonnage?.errors?.max" class="red">
                                {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_Gross_TONNAGE' | translate}}
                            </div>
                        </div>
                    </div>
                    <p class="btns-holder text-right">
                        <button type="button" class="btn  SCAcustomBtn" (click)="selectTab(1)">{{ 'FRONT_USER.NEXT' |
                            translate}}</button>
                    </p>
                </tab>
                <tab #tabTwoControls heading="{{ 'FRONT_USER.small_units.REQUIRED_DOCUMENTS' | translate}}"
                    [disabled]="!isTabOneValid">
                    <div class="bs-callout bs-callout-info">
                        <h4>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENTS_TO_BE_UPLOADED' | translate}}</h4>
                        <ul>
                            <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.Crew_Cert' | translate}}</li>
                            <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SHIP_REGISTER' | translate}}</li>
                            <li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.Port_calls' | translate}}</li>
                            <!--<li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.B_L_CERT' | translate}}</li>-->
                            <!--<li>{{ 'FRONT_USER.FEES_ESTIMATION_FORM.STOWAGE_PLAN' | translate}}</li>-->
                        </ul>
                    </div>
                    <div formArrayName="Attachments">
                        <div *ngFor="let attachment of entranceRequestForm.get('Attachments')['controls']; let i=index; let last = last"
                            [formGroupName]="i">
                            <div class="form-container">
                                <div class="form-group">
                                    <label for="DocumentName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT_NAME' |
                                        translate}}</label>
                                    <span class="red">*</span>
                                    <input type="text" formControlName="DocumentName" class="form-control"
                                        [ngClass]="{ 'is-invalid':formSubmitted ||( attachment.get('DocumentName')?.dirty && attachment.get('DocumentName')?.errors) }" />
                                    <div *ngIf=" formSubmitted ||(attachment.get('DocumentName')?.dirty && attachment.get('DocumentName')?.errors)"
                                        class="red ">
                                        <div *ngIf="attachment.get('DocumentName')?.errors?.required">
                                            {{'FRONT_USER.This_Field_Is_Required' | translate}}
                                        </div>
                                    </div>
                                </div>


                                <div *ngIf="formMode != FormMode.Readonly" class="form-group">
                                    <label for="URL">{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'| translate}}</label>
                                    <span class="red"> *</span>

                                    <input type="file"
                                        accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
                                        MaxSizeInMB="5" class="form-control" id="URL" formControlName="URL"
                                        (change)="onFileSelected($event,attachment.get('URL'),i,'documentsProgress'+i)" />
                                    <div class="upload-info">
                                        <span data-toggle="tooltip"
                                            title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle'
                                            | translate}}</span>
                                        <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
                                    </div>
                                    <div class="progress">
                                        <div *ngIf="i==0" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress0+'%'">

                                            <span class=""> {{ documentsProgress0 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==1" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress1+'%'">

                                            <span class=""> {{ documentsProgress1 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==2" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress2+'%'">

                                            <span class=""> {{ documentsProgress2 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==3" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress3+'%'">

                                            <span class=""> {{ documentsProgress3 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==4" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress4+'%'">

                                            <span class=""> {{ documentsProgress4 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==5" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress5+'%'">

                                            <span class=""> {{ documentsProgress5 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==6" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress6+'%'">

                                            <span class=""> {{ documentsProgress6 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==7" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress7+'%'">

                                            <span class=""> {{ documentsProgress7 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==8" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress8+'%'">

                                            <span class=""> {{ documentsProgress8 }} % Complete</span>
                                        </div>
                                        <div *ngIf="i==9" class="progress-bar" role="progressbar" aria-valuenow="70"
                                            aria-valuemin="0" aria-valuemax="100"
                                            [style.width]="documentsProgress9+'%'">

                                            <span class=""> {{ documentsProgress9 }} % Complete</span>
                                        </div>
                                    </div>


                                    <div *ngIf=" formSubmitted ||(attachment.get('URL')?.dirty &&  attachment.get('URL')?.errors)"
                                        class="red">
                                        <div *ngIf="attachment.get('URL')?.errors?.required">
                                            {{'FRONT_USER.This_Field_Is_Required'| translate}}
                                        </div>
                                        <div *ngIf="attachment.get('URL').errors?.notCompleted">
                                            {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add">
                                    <label>{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'|translate}}</label>

                                    <a [attr.href]="uploadUrl+uploadFolder+'/'+RequestAttachments[i]?.URL"
                                        target="_blank">
                                        <i class="icon-view-file"></i>
                                        {{RequestAttachments[i]?.DocumentName}}
                                    </a>
                                </div>
                                <input type="hidden" formControlName="AttachmentTypeId" [ngModel]="AttachmentType">

                                <p *ngIf="formMode != FormMode.Readonly">
                                    <button type="button" class="btn SCAcustomBtn" Confirmation
                                        (confirmationClick)="deleteAttachments(i,'documentsProgress'+i)"
                                        *ngIf="getAttachmentsLengthGetter > 1">
                                        {{'FRONT_USER.DELETE' | translate }}
                                    </button>
                                </p>

                            </div>
                            <!-- *ngIf="!(i>8) && last" this condition for the agent can add up to 10 documents  -->
                            <p *ngIf="!(i>8) && last && formMode != FormMode.Readonly " class="btns-holder text-right">
                                <button type="button" class="btn SCAcustomBtn" Confirmation
                                    (confirmationClick)="addAttachments()">(+)
                                    {{'FRONT_USER.ADD' | translate }}</button>
                            </p>

                        </div>
                    </div>
                    <!-- <div class="form-group" *ngIf="formMode != FormMode.Readonly">
                        <label for="GunsAndDrones">{{ 'FRONT_USER.GunsAndDrones' | translate }}</label>
                        <span class="red"> *</span>
                        <div class="form-custom-inputs">
                            <div class="custom-checkbox">
                                <input type="checkbox" id="GunsAndDrones" name="GunsAndDrones"
                                    formControlName="GunsAndDrones" />
                                <label for="GunsAndDrones">
                                    {{ 'FRONT_USER.GunsAndDrones_ACCEPTANCE' | translate }}
                                </label>
                            </div>
                        </div>
                        <div *ngIf="formSubmitted ||(f.GunsAndDrones.dirty && f.GunsAndDrones?.errors)"
                            class="red ">
                            <div *ngIf="f.GunsAndDrones?.errors?.required">
                                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
                        </div>
                    </div>-->
                    <div class="form-group" *ngIf="formMode != FormMode.Readonly">
                        <label for="TermsAndConditions">{{ 'FRONT_USER.TERMS_CONDITIONS' | translate }}</label>
                        <span class="red"> *</span>
                        <div class="form-custom-inputs">
                            <div class="custom-checkbox">
                                <input type="checkbox" id="TermsAndConditions" name="TermsAndConditions"
                                    formControlName="TermsAndConditions" />
                                <label for="TermsAndConditions">
                                    <a (click)="goToTermsAndCond()" target="_blank">
                                        {{ 'FRONT_USER.TERMS_CONDITIONS_Acceptence' | translate }}
                                    </a>
                                </label>
                            </div>
                        </div>
                        <div *ngIf="formSubmitted ||(f.TermsAndConditions.dirty && f.TermsAndConditions?.errors)"
                            class="red ">
                            <div *ngIf="f.TermsAndConditions?.errors?.required">
                                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
                        </div>
                    </div>

                    <p class="btns-holder text-right">
                        <button type="button" class="btn  SCAcustomBtn" (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS'
                            |
                            translate}}</button>
                    </p>
                </tab>

            </tabset>
        </div>

        <p class="form-group" *ngIf="validateSubmitButton && formMode != FormMode.Readonly">
            <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
                'FRONT_USER.SAVE'
                | translate}}</button>
        </p>
    </form>
</div>
<!-- Confirmation -->

<div *ngIf="showRequest && !isErrorMessage" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>

        </svg>

        <p>{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
                {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>


<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">

    <div class="alignC">
        <i class="icon-error"></i>

        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
                {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>

<div *ngIf="!showRequest && ( (!loggedInUser.IsAdmin && loggedInUser.UserId == agentId) || loggedInUser.IsAdmin )">
    <app-messaging></app-messaging>
</div>